export function getMeetingElapsedMs(
	scheduledStartMs: number,
	nowMs = Date.now(),
): number {
	return Math.max(0, nowMs - scheduledStartMs);
}

export function isMeetingNotYetStarted(
	scheduledStartMs: number,
	nowMs = Date.now(),
): boolean {
	return nowMs < scheduledStartMs;
}

export function formatMeetingScheduledStartTime(
	scheduledStartMs: number,
): string {
	return new Date(scheduledStartMs).toLocaleTimeString('pt-BR', {
		hour: '2-digit',
		minute: '2-digit',
	});
}

export function formatMeetingElapsedTime(elapsedMs: number): string {
	const totalSeconds = Math.floor(elapsedMs / 1000);
	const minutes = Math.floor(totalSeconds / 60);
	const seconds = totalSeconds % 60;

	return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
		2,
		'0',
	)}`;
}
